<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-list'"></top-line>
    <el-row class="pagebody">
      <el-row style="margin-bottom: 15px;">
        <el-button type="primary" icon="el-icon-back" size="medium" plain @click="goBack" />
      </el-row>
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row>
              <el-col :span="6">
                <el-form-item label="用户：" prop="namespace" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.namespace" style="width:175px" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时间范围：" class="search-item" :label-width="labelWidth">
                  <el-date-picker
                      v-model="period" type="daterange" align="right"
                      unlink-panels range-separator="-"
                      start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="timePickerOptions"
                      @change="onDateChange()" />
                  &nbsp;
                  <el-tooltip content="上个自然月" placement="top">
                    <el-button type="primary" icon="el-icon-arrow-left" plain
                               @click="handleLastMonth" circle />
                  </el-tooltip>
                  <el-tooltip content="本月" placement="top">
                    <el-button type="primary" icon="el-icon-refresh-right" plain
                               @click="initDate" circle />
                  </el-tooltip>
                  <el-tooltip content="下个自然月" placement="top">
                    <el-button type="primary" icon="el-icon-arrow-right" plain
                               @click="handleNextMonth"  circle />
                  </el-tooltip>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>
            </el-row>
            <!--
            <el-row>
              <el-col :span="6">
                <el-form-item label="用户：" prop="namespace" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.namespace" style="width:175px" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="应用类型：" prop="appKind" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.appKind" clearable placeholder="" style="width:180px">
                    <el-option v-for="st in appKindList" :key="st.value" :label="st.label" :value="st.value" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="应用名称：" prop="appName" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.appName" style="width:175px" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="部署名称：" prop="deployName" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.deployName" style="width:175px" />
                </el-form-item>
              </el-col>
            </el-row>
            -->
          </el-form>
        </el-card>
      </el-row>

      <el-row class="main-table">
        <el-table :data="tableData" border="border">
          <el-table-column prop="id" label="ID" width="65px" />
          <el-table-column prop="namespace" label="用户" width="120" />
          <el-table-column prop="app_kind" label="应用类型" width="95px" />
          <el-table-column prop="app_name" label="应用名称" width="300px" />
          <el-table-column prop="deploy_name" label="部署名称" width="300px" />
          <el-table-column prop="model_name" label="显卡型号" width="220px" />
          <el-table-column prop="usage" label="使用时间（秒）" align="right" width="120px" />
          <el-table-column prop="cost" label="计费（元）" align="right" width="120px" :formatter="formatCost" />
          <el-table-column prop="price_second" label="价格（元/秒）" align="right" width="120px" />
          <!-- <el-table-column prop="gpu_i_profile" label="显卡配置" width="120px" /> -->
          <el-table-column prop="deleted" label="删除" align="center" width="60px">
            <template v-slot="scope">
              <span v-if="scope.row.deleted">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="180px" />
          <el-table-column prop="delete_time" label="删除时间" width="180px">
            <template v-slot="scope">
              <span v-if="scope.row.deleted">{{ scope.row.delete_time }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="duration_time" label="使用时间" width="150px" /> -->
        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>

    </el-row>
  </d2-container>
</template>

<script>

import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";

const APPKINDList = [
    {
      value: 'ReplicaSet',
      label: 'ReplicaSet'
    },
    {
      value: 'Deployment',
      label: 'Deployment'
    },
    {
      value: 'DaemonSet',
      label: 'DaemonSet'
    },
    {
      value: 'StatefulSet',
      label: 'StatefulSet'
    },
    {
      value: 'Job',
      label: 'Job'
    },
    {
      value: 'CronJob',
      label: 'CronJob'
    },
]

export default {
  name: "allns",
  mixins: [
    commonListMixin
  ],
  components: {
    topLine,
  },
  data() {
    return {
      pageTitle: "Pod用量明细",
      labelWidth: '120px',
      tableDataApi: '/api/pod-usage',

      searchForm: {
        namespace: '', //this.$route.query.namespace === null ? '' : this.$router.query.namespace,
        gpuModel: '',
        appKind: '',
        appName: '',
        deployName: '',
        gpuProfile: '',
        from: '', //this.$route.query.from === null ? '' : this.$router.query.namespace,
        to: '', //this.$route.query.to === null ? '' : this.$router.query.namespace,
      },
      orgParams: {
        namespace: '',
        from: '',
        to: '',
        page: 1, 
        pageSize: 10,
        total: 0,
      },
      period: [],
      currentRow: {},
      gpuUsage: [],
      appKindList: APPKINDList,
    }
  },
  computed: {
  },
  mounted() {
    this.initDate()
    this.loadParams()
    this.updateDatePicker()
  },
  methods: {
    loadParams () {
      console.log('+++ pod-usage +++', this.$route.query)

      if('from' in this.$route.query && this.$route.query.from) {
        let day = new Date(this.$route.query.from)
        this.searchForm.from = this.getDateStr(day, '00:00:00');
      }
      if('to' in this.$route.query && this.$route.query.to) {
        let day = new Date(this.$route.query.to)
        this.searchForm.to = this.getDateStr(day, '23:59:59');
      }
      if('namespace' in this.$route.query && this.$route.query.namespace) {
        this.searchForm.namespace = this.$route.query.namespace
      }

      if('orgFrom' in this.$route.query && this.$route.query.orgFrom) {
        let day = new Date(this.$route.query.from)
        this.orgParams.from = this.getDateStr(day, '00:00:00');
      }
      if('orgTo' in this.$route.query && this.$route.query.orgTo) {
        let day = new Date(this.$route.query.to)
        this.orgParams.to = this.getDateStr(day, '23:59:59');
      }
      if('orgNamespace' in this.$route.query && this.$route.query.orgNamespace) {
        this.orgParams.namespace = this.$route.query.orgNamespace
      }
      if('orgPage' in this.$route.query && this.$route.query.orgPage) {
        this.orgParams.page = this.$route.query.orgPage
      }
      if('orgPageSize' in this.$route.query && this.$route.query.orgPageSize) {
        this.orgParams.pageSize = this.$route.query.orgPageSize
      }
      if('orgTotal' in this.$route.query && this.$route.query.orgTotal) {
        this.orgParams.total = this.$route.query.orgTotal
      }

      this.getTableData()
    },

    handleSearch() {
      this.getTableData();
      this.updateDatePicker();
    },
    handleReset() {
      this.searchForm = {
        gpuModel: '',
        appKind: '',
        appName: '',
        deployName: '',
        gpuProfile: '',
        from: '',
        to: '',
      }
      this.initDate();
      this.getTableData();
      this.updateDatePicker();
    },

    goBack () {
      this.$router.push({
        path: '/user-cost',
        query: {
          from: this.orgParams.from,
          to: this.orgParams.to,
          namespace: this.orgParams.namespace,
          page: this.orgParams.page,
          pageSize: this.orgParams.pageSize,
          total: this.orgParams.total,
        }
      })
    },

    formatCost (value) {
      return parseFloat(value.cost).toFixed(2)
    },


    //////////////////////////////////////////////
    /////////////// BEGIN - 时间段处理
    // 日期字符串处理
    getDateStr(d, time) {
      let str = d.getFullYear();
      str += "-";
      let MM = d.getMonth()+1;
      if(MM<10) str += '0' + MM;
      else str += MM;
      str += "-";
      let dd = d.getDate();
      if(dd<10) str += '0' + dd;
      else str += dd;
      if(time.length<1) str += " 00:00:00";
      else str += " " + time;
      return str;
    },
    // 回显到el-date-picker
    updateDatePicker() {
      this.$nextTick(() => {
        this.period = [this.searchForm.from, this.searchForm.to];
      })
    },
    initDate() {
      let day = new Date();
      day.setMonth(day.getMonth(), 1);
      this.searchForm.from = this.getDateStr(day, '00:00:00');
      day.setMonth(day.getMonth()+1, 0);
      this.searchForm.to = this.getDateStr(day, '23:59:59');
      this.updateDatePicker();

      this.getTableData();     // 请求数据
    },
    onDateChange() {
      if(this.period==null || this.period[0]==null) {
        this.initDate();
      }
      let from = new Date(this.period[0])
      let to = new Date(this.period[1])
      this.searchForm.from = this.getDateStr(from, '00:00:00')
      this.searchForm.to = this.getDateStr(to, '23:59:59')
      this.updateDatePicker()
    },
    handleLastMonth () {
      if(this.period==null || this.period[0]==null) {
        this.initDate()
      }
      // let from = new Date(this.searchForm.from)
      // from.setMonth(from.getMonth() - 1)
      // let to = new Date(this.searchForm.to)
      // to.setMonth(to.getMonth() - 1)
      // this.searchForm.from = this.getDateStr(from, '00:00:00')
      // this.searchForm.to = this.getDateStr(to, '23:59:59')
      let day = new Date(this.searchForm.from)
      day.setMonth(day.getMonth() - 1, 1)
      this.searchForm.from = this.getDateStr(day, '00:00:00');
      day.setMonth(day.getMonth()+1, 0);
      this.searchForm.to = this.getDateStr(day, '23:59:59');
      this.updateDatePicker()

      this.getTableData();     // 请求数据
    },
    handleNextMonth () {
      if(this.period==null || this.period[0]==null) {
        this.initDate()
      }
      let day = new Date(this.searchForm.from)
      day.setMonth(day.getMonth() + 1, 1)
      this.searchForm.from = this.getDateStr(day, '00:00:00');
      day.setMonth(day.getMonth() + 1, 0);
      this.searchForm.to = this.getDateStr(day, '23:59:59');
      this.updateDatePicker()

      this.getTableData();     // 请求数据
    },
    /////////////// END - 时间段处理
    //////////////////////////////////////////////

  }

}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
  min-width: 1390px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>
